import { Redirect } from "react-router-dom";

const AuthGuard = ({ children, allowedRoles }) => {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");

  if (!token) {
    //return <Redirect to="/login" replace />;
    return <Redirect to="/" replace />;
  }

  if (!allowedRoles.includes(role)) {
    return <Redirect to="/unauthorized" replace />;
  }

  return children;
};

export default AuthGuard;

//here if there an issues of token for example if you do logout and try to back to the page throw the arrow in browser it will throw you to login page !
